import { render } from "./Show.vue?vue&type=template&id=2f301930&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"

import "./Show.vue?vue&type=style&index=0&id=2f301930&scoped=true&lang=scss"
import "./Show.vue?vue&type=style&index=1&id=2f301930&lang=scss"
script.render = render
script.__scopeId = "data-v-2f301930"

export default script